import styled from '@emotion/styled';

const LayoutPageContent = styled.div`
  grid-area: page-content;
`;

export default LayoutPageContent;
